module.exports = __webpack_public_path__ + "static/logistics-drive-store@2x-ea353d866b055ab402e9ea868c60c794.png";